import { usePageContext } from "vike-react/usePageContext"

export function PageLayout({ children }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "100%",
        margin: "auto",
      }}
    >
      {children}
    </div>
  )
}

export function Content({ children }) {
  const pageContext = usePageContext()
  //const isAdmin = pageContext?.urlPathname?.startsWith("/admin")

  return (
    <div
      className="bg-paper transition-colors"
      style={{ minHeight: "100vh" }}
    >
      {children}
    </div>
  )
}
